// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__J4xV7","title":"ClientCherryInfo_title__6UdD-","itemText":"ClientCherryInfo_itemText__zjYe_"};